// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Warp Gates Configuration - Universe Dungeon Dimensions
 * 
 * Return gate to Discworld universe and potential future gates to other realms.
 * The Dungeon Dimensions exist outside normal space-time, accessible only
 * through narrative causality rifts.
 */

export const warpGates = [
  {
    id: 'gate_dungeon_to_discworld',
    name: 'NARRATIVE CAUSALITY RIFT',
    type: 'warpgate',
    distance: 0,
    destinationUniverse: 'discworld',
    destinationGate: 'gate_discworld_to_dungeon',
    toSystem: 500,
    fuelRequired: 5,
    threat: 'ELDRITCH',
    resources: 'CONCEPTUAL BREACH',
    services: [],
    primaryColor: '#8B008B',
    secondaryColor: '#4B0082',
    hasRings: true,
    animated: true,
    discovered: true,
    description: 'Unstable rift back to Discworld reality. Narrative causality maintains connection despite impossible geometry. Passage may cause temporary madness. Gate travel does not consume fuel.',
    scanDescription: 'ANALYSIS: Conceptual breach to "Discworld" reality plane. WARNING: Non-Euclidean transit detected. Sanity protocols recommended. No fuel consumption.',
  },
  {
    id: 'gate-dungeon-dimensions-warhammer40k',
    name: 'WARP CONVERGENCE',
    type: 'warpgate',
    distance: 50,
    destinationUniverse: 'warhammer40k',
    destinationGate: 'gate-warhammer40k-dungeon-dimensions',
    toSystem: 1111,
    fuelRequired: 5,
    threat: 'EXTREME',
    resources: 'CHAOS ENERGY',
    services: [],
    primaryColor: '#8B008B',
    secondaryColor: '#ff0000',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Warp rift to Imperium space. Chaos and madness converge. The Emperor may not protect here.',
    scanDescription: 'ANALYSIS: Warp breach to Warhammer 40K universe. Immaterium connection. WARNING: Daemon incursion possible. No fuel consumption.',
  }
];

// Warp gate positions on the map
export const warpGatePositions = {
  'gate_dungeon_to_discworld': { x: 30, y: 50, z: 0 }, // Same position as THE SCREAMING VOID
  'gate-dungeon-dimensions-warhammer40k': { x: 60, y: 50, z: -15 },
};
